'use strict';

var MOBILE_SCREEN_WIDTH = 768;
var TABLET_SCREEN_WIDTH = 1440;

exports.MOBILE_SCREEN_WIDTH = MOBILE_SCREEN_WIDTH;
exports.TABLET_SCREEN_WIDTH = TABLET_SCREEN_WIDTH;
//# sourceMappingURL=screen.js.map
